/* global axios */
import { msBaseUrl } from './microservicos';

export const personContactsAPI = {
  getByPerson(accountId, personId) {
    return axios.get(`${msBaseUrl('crm', accountId)}/person-contacts`, {
      params: { personId },
    });
  },

  create(accountId, data) {
    return axios.post(`${msBaseUrl('crm', accountId)}/person-contacts`, data);
  },

  delete(accountId, id) {
    return axios.delete(`${msBaseUrl('crm', accountId)}/person-contacts/${id}`);
  },
};
